import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingPhoto } from './types/Listing';

interface PhotoParams {
  format?: string;
  crop?: boolean;
}

export default (makeCall: MakeCall) =>
  (listingId: number, { format, crop }: PhotoParams) =>
    makeCall<ListingPhoto[]>('GET', `/api/v2/listing/${listingId}/photos`, {
      query: { format, crop },
    });
